import cn from "clsx";
import Avatar from "@mui/material/Avatar";
import UKToast from '@/components/UKToast';
import CustomTextarea from "./customTextArea";
import IntlDialog from "@/components/intlMui/dialog";

import { SubmitButton } from "../intlMui/button";
import { useState, useEffect, useRef } from "react";
import { callAfterLogin, JDILogin } from "@/lib/jdiClientUtils";
import { publishReplyComment, handleDeleteReply } from "@/apis/service";
import { sendClickTrack } from "@/tracks/25217";
import { avatarFn } from "@/utils";
const ReplyItem = ({isOpenDetailDialog = false, isCustomer = false, onReplyChange, ...rest }: any ) => {
    const [isShowReply, setIsShowReply] = useState<boolean>(false)
    const [replyContent, setReplyContent] = useState<string>('')
    const [isDelete, setIsDelete] = useState<boolean>(false);
    const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
    const  currentRef = useRef<HTMLDivElement>(null);
    const {
        item: {
            userNickName,
            userImage,
            content, 
            commentDate, 
            parentReplyId,
            id: targetReplyId,
            replyNickname,
            canDelete,
            tag
        }, 
        extraData: {
            commentId,
            skuId
        } = {}
    } = rest || {}
    const onTextareaChange = (value: string)=> {
        setReplyContent(value);
    }

    const onSecondaryReply = ()=> {
        sendClickTrack.Productdetail_ReviewsFloor_CommentBtn_Click();
        if(!isOpenDetailDialog) {
            setIsShowReply((preState)=> !preState);
        }
    }
    const onReplyDelete = async () => {
        const res = await handleDeleteReply({ replyId: targetReplyId, skuId });
        if (res?.data?.deleteResult) {
          setIsDelete(true);
          // onDetailRefresh?.({ commentId, parentReplyId: 0 });
        }
      };


    const onSecondaryReplySubmit = async () => {
      const parentContainer = currentRef?.current?.closest(".MuiDialog-container");
        if (parentContainer) {
            parentContainer.removeAttribute('tabindex')
        }
        callAfterLogin(async ()=> {
          const userInfo = await JDILogin.getInstance().getUserInfo();
          if (userInfo.isLoggedIn) {
            const res = await publishReplyComment({
              targetReplyId,
              parentReplyId,
              anonymousFlag: false,
              commentId,
              content: replyContent,
            });
    
            const { saveResult, ...dataRest } = res?.data || {};
            if (saveResult) {
              onReplyChange?.({
                ...dataRest,
                replyNickname: userNickName,
                content: replyContent,
                canDelete: true
              });
              setReplyContent("");
              setIsShowReply(false);
            } else {
                UKToast.show({
                    icon: "error",
                    content: res.msg,
                });
            }
          }
      })
      
      };
      if (isDelete) {
        return null;
      }
    return <div className="child depth-2" style={{padding: "10px 0"}}>
    <div className="child-header">
        <div className="avatar" style={{display: "flex", alignItems: "center"}}>
            {/* <CDNImage src={userImage} width={20} height={20} alt=""/> */}
            <Avatar
                sizes="20"
                src={avatarFn(userImage) || ""}
                alt=""
                slotProps={{
                img: {
                    loading: "lazy",
                },
                }}
                sx={{
                  width: "25px",
                  height: "25px",
                  bgcolor: "#E1E3E6",
                  "& .MuiSvgIcon-root": {
                      width: "100%",
                      height: "100%",
                      fill: "#F0F1F2",
                  },
                }}
            />
            <span style={{ marginLeft: '6px' }}>{userNickName}</span>
            {tag && (<span className={cn("tag", tag == "From Joybuy" && "tagJoy", tag == "Author" && "tagAuthor")}>{tag}</span>)}
        </div>
        <div className="date-time">{commentDate}</div>
    </div>
    <div className="content">
        <div className="static-text">
        {replyNickname && (
            <span className="replyNickName">Reply {replyNickname.length >= 20 ? `${replyNickname?.slice(0, 19)}...` : replyNickname}</span>
          )}
            <span>{content}</span>
        </div>
        {!isCustomer && <div className="reply-btn">
        {canDelete && <span onClick={()=> setDeleteOpen(true)}>Delete</span>}
            <span onClick={onSecondaryReply}>Reply</span>
        </div>}
    </div>
    { isShowReply && <div className="comment-reply">
        <CustomTextarea onChange={onTextareaChange} placeholder={'You may add any supplementary information in this section.'}></CustomTextarea>
        <p className="opt" ref={currentRef}><SubmitButton onClick={() => replyContent && onSecondaryReplySubmit()}>Submit</SubmitButton></p>
    </div>}
        <IntlDialog
            onClose={() => setDeleteOpen(false)}
            aria-labelledby="customized-dialog-title"
            open={deleteOpen}
            title='Delete warning'
            content={<>
                <div className="report-reason-wrapper">
                    Please confirm you want to delete your review?This action cannot be undone!
                </div>
            </>}
            onSubmit={onReplyDelete}
            onCancel={() => setDeleteOpen(false)}
        />
</div>
}
export default function SecondaryReplyList(props: any) {
    
    const { replyList =[], customReplyList, ...rest  } = props
    const [innerCustomReplyList, setInnerCustomReplyList] = useState<any[]>(
        customReplyList || [],
    );
    const onReplyChange = (value: any) => {
        setInnerCustomReplyList([value, ...innerCustomReplyList]);
    };
    useEffect(() => {
        setInnerCustomReplyList(customReplyList || []);
    }, [customReplyList]);
    return <div className="secondary-reply-list">
      {/*   {innerCustomReplyList?.map((item: any) => {*/}
      {/*  return <ReplyItem key={item.id} item={item} isCustomer={false}/>;*/}
      {/*})}*/}
      {[...innerCustomReplyList, ...replyList].map((item: any) => {
          return (
            <ReplyItem
              key={item.id}
              item={item}
              onReplyChange={onReplyChange}
              {...rest}
            />
          );
        })
      }
      {/* {
        !isOpenDetailDialog && (
        )
      } */}
</div>
}